var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[(_vm.loading)?_c('div',{staticClass:"mt-5"},[_c('div',{staticClass:"mt-5"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('loader')],1)]):_c('div',{staticClass:"errorClass"})])
}
var staticRenderFns = []

export { render, staticRenderFns }